export enum GroupOrigin {
    Marketing = 1,
    Sales = 2,
    Partner = 3,
    Indication = 4
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/GroupOrigin.ts